export default function SwingThumbnailIcon({
  className,
  processing = false,
}: {
  className?: string;
  /** Outline-only sheets (no white fill), for in-progress batch tiles. */
  processing?: boolean;
}) {
  const sheetFill = processing ? 'none' : 'white';

  return (
    <svg
      className={className}
      viewBox="0 0 90 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9619 1H50.6689C52.4285 1.00002 53.9379 1.12595 55.2061 1.36816L55.2168 1.37012L55.2266 1.37109C56.4605 1.5806 57.5939 1.98556 58.6338 2.58203L58.6426 2.58594L58.6504 2.59082C59.6876 3.15987 60.785 4.02024 61.9395 5.19922L61.9424 5.20117L84.4531 28.042L84.459 28.0479C85.6717 29.2575 86.5491 30.3954 87.1201 31.457L87.1338 31.4824C87.7279 32.513 88.1346 33.6682 88.3457 34.958V34.9619C88.5627 36.2608 88.6758 37.8873 88.6758 39.8535V78.7217C88.6757 83.1591 87.5443 86.3513 85.4424 88.4736L85.4385 88.4775C83.3397 90.6222 80.1589 91.7773 75.7139 91.7773H29.9619C25.5138 91.7773 22.3317 90.6351 20.2334 88.5166C18.1325 86.3953 17.0001 83.1897 17 78.7217V14.0557C17 9.61818 18.1314 6.42608 20.2334 4.30371L20.2373 4.29883C22.3361 2.15421 25.517 1 29.9619 1Z"
        fill={sheetFill}
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M57 1V16.5C57 25.3366 64.1634 32.5 73 32.5H88.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M21.9619 9H42.6689C44.4285 9.00002 45.9379 9.12595 47.2061 9.36816L47.2168 9.37012L47.2266 9.37109C48.4605 9.5806 49.5939 9.98556 50.6338 10.582L50.6426 10.5859L50.6504 10.5908C51.6876 11.1599 52.785 12.0202 53.9395 13.1992L53.9424 13.2012L76.4531 36.042L76.459 36.0479C77.6717 37.2575 78.5491 38.3954 79.1201 39.457L79.1338 39.4824C79.7279 40.513 80.1346 41.6682 80.3457 42.958V42.9619C80.5627 44.2608 80.6758 45.8873 80.6758 47.8535V86.7217C80.6757 91.1591 79.5443 94.3513 77.4424 96.4736L77.4385 96.4775C75.3397 98.6222 72.1589 99.7773 67.7139 99.7773H21.9619C17.5138 99.7773 14.3317 98.6351 12.2334 96.5166C10.1325 94.3953 9.00008 91.1897 9 86.7217V22.0557C9.00003 17.6182 10.1314 14.4261 12.2334 12.3037L12.2373 12.2988C14.3361 10.1542 17.517 9 21.9619 9Z"
        fill={sheetFill}
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M49 9V24.5C49 33.3366 56.1634 40.5 65 40.5H80.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M13.9619 17H34.6689C36.4285 17 37.9379 17.1259 39.2061 17.3682L39.2168 17.3701L39.2266 17.3711C40.4605 17.5806 41.5939 17.9856 42.6338 18.582L42.6426 18.5859L42.6504 18.5908C43.6876 19.1599 44.785 20.0202 45.9395 21.1992L45.9424 21.2012L68.4531 44.042L68.459 44.0479C69.6717 45.2575 70.5491 46.3954 71.1201 47.457L71.1338 47.4824C71.7279 48.513 72.1346 49.6682 72.3457 50.958V50.9619C72.5627 52.2608 72.6758 53.8873 72.6758 55.8535V94.7217C72.6757 99.1591 71.5443 102.351 69.4424 104.474L69.4385 104.478C67.3397 106.622 64.1589 107.777 59.7139 107.777H13.9619C9.51384 107.777 6.3317 106.635 4.2334 104.517C2.13248 102.395 1.00008 99.1897 1 94.7217V30.0557C1.00003 25.6182 2.13144 22.4261 4.2334 20.3037L4.2373 20.2988C6.33612 18.1542 9.51696 17 13.9619 17Z"
        fill={sheetFill}
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M41 17V32.5C41 41.3366 48.1634 48.5 57 48.5H72.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M51.244 74.327C50.2507 74.327 49.2471 74.0684 48.6159 73.5614V72.1956C49.1746 72.7026 50.0438 73.044 50.975 73.044C52.5788 73.044 53.3238 72.2266 53.3238 70.8298V70.4469C52.8685 71.4299 52.0718 71.9679 50.944 71.9679C49.2057 71.9679 48.0675 70.7263 48.0675 69.0294C48.0675 67.2187 49.2884 65.9771 51.006 65.9771C52.1339 65.9771 52.8581 66.4944 53.3238 67.4567V66.2254H55V71.0264C55 73.1164 53.541 74.327 51.244 74.327ZM51.5337 70.7056C52.6305 70.7056 53.3444 69.9813 53.3444 68.9984C53.3444 68.0154 52.6409 67.3015 51.5648 67.3015C50.4887 67.3015 49.8161 68.0361 49.8161 69.0294C49.8161 70.002 50.4887 70.7056 51.5337 70.7056Z"
        fill="currentColor"
      />
      <path
        d="M40.5583 72.1956V66.2254H42.2242V67.6222C42.6484 66.5151 43.4038 65.9771 44.5523 65.9771C46.1043 65.9771 46.9838 67.0014 46.9838 68.8328V72.1956H45.2973V69.2053C45.2973 67.9947 44.8213 67.4153 43.8487 67.4153C42.7933 67.4153 42.2346 68.1292 42.2346 69.1536V72.1956H40.5583Z"
        fill="currentColor"
      />
      <path
        d="M37.3254 72.1956V66.4116H39.012V72.1956H37.3254ZM38.1739 65.9357C37.6048 65.9357 37.1909 65.5839 37.1909 65.1182C37.1909 64.6526 37.6151 64.3215 38.1739 64.3215C38.7326 64.3215 39.1465 64.6526 39.1465 65.1182C39.1465 65.5839 38.7326 65.9357 38.1739 65.9357Z"
        fill="currentColor"
      />
      <path
        d="M28.0093 72.1955L26.0641 66.2253H27.8334L28.9716 70.3641L30.3581 66.2253H32.1171L33.4932 70.3848L34.7038 66.2253H36.4007L34.4244 72.1955H32.6551L31.1858 67.8602L29.7373 72.1955H28.0093Z"
        fill="currentColor"
      />
      <path
        d="M22.3078 72.3922C21.0765 72.3922 19.9694 72.0404 19.1727 71.492V70.0537C20.0211 70.6435 21.0248 71.0264 22.1629 71.0264C23.1666 71.0264 23.7046 70.747 23.7046 70.1572C23.7046 69.7433 23.446 69.5054 22.5872 69.2881L21.2421 68.9984C19.7521 68.6569 19.152 67.9533 19.152 66.9497C19.152 65.677 20.2798 64.7561 22.3802 64.7561C23.715 64.7561 24.6152 65.1389 25.1532 65.5114V66.9083C24.5531 66.4737 23.6322 66.1426 22.5251 66.1426C21.4697 66.1426 20.9523 66.4323 20.9523 66.9186C20.9523 67.2704 21.2007 67.4877 21.9457 67.6532L23.3528 67.9637C24.8635 68.2948 25.5154 68.9466 25.5154 70.0537C25.5154 71.4609 24.2634 72.3922 22.3078 72.3922Z"
        fill="currentColor"
      />
    </svg>
  );
}
